import React, { PropTypes } from 'react';
import FormRow from 'components/FormRow';
import TextField from 'components/TextField';
import Button from 'components/Button';
import StarRating from 'components/StarRating';
import cx from './ReviewForm.scss';

import withStyles from 'decorators/withStyles';

@withStyles(cx)
export default class ReviewForm extends React.Component {

  static propTypes = {
    review: PropTypes.object.isRequired,
    onChange: PropTypes.func,
    onSubmit: PropTypes.func,
    sending: PropTypes.bool,
  };

  render() {
    const { review, onChange, onSubmit, sending = false } = this.props;
    const filled = review.get('rating') && review.get('text', '').trim().length > 0;

    return (
      <div className={cx('main')}>
        <FormRow>
          <h3 className={cx('title')}>
            {__('rate_coach')}
          </h3>
          <StarRating
            value={review.get('rating')}
            size="m"
            onChange={rating => onChange(review.set('rating', rating))}
            />
        </FormRow>
        <FormRow>
          <TextField
            value={review.get('text')}
            onChange={text => onChange(review.set('text', text))}
            />
        </FormRow>
        <FormRow>
          <Button
            onClick={onSubmit}
            process={sending}
            disabled={!filled}
          >
            {__('send')}
          </Button>
        </FormRow>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/react/elements/ReviewList/ReviewForm.js